import React from 'react';

import { postUrl } from '@/apiCalls/fetch';
import { fetchPreapprovalVerdict } from '@/apiCalls/fetchPreapprovalVerdict';
import { Button, EButtonType } from '@/components/Button';
import { setAgreedToTestDriveAgreement } from '@/context/borrower';
import { EDisplays, setDisplay } from '@/context/display';
import { store } from '@/context/store';
import { useAppDispatch } from '@/context/storeHooks';
import { MINIMUM_TEST_DRIVE_SEEKER_SCORE } from '@/utils/constants';
interface ITestDriveAgreementButton {
    baseId: string;
    disabled: boolean;
}

export function TestDriveAgreementButton({
    baseId,
    disabled,
}: ITestDriveAgreementButton): JSX.Element {
    // ***** Redux *****
    const dispatch = useAppDispatch();
    const state = store.getState();

    // ***** Handlers *****
    async function handleClick(): Promise<void> {
        if (disabled) return;
        dispatch(setAgreedToTestDriveAgreement(true));
        const response = await fetchPreapprovalVerdict(true);
        const customerName = state.borrowerReducer.personalDetails.firstName;
        const applicationId = state.borrowerReducer.application.applicationId;

        if (
            response.comprehensiveScore === null ||
            (response.comprehensiveScore &&
                response?.comprehensiveScore <
                    Number(MINIMUM_TEST_DRIVE_SEEKER_SCORE))
        ) {
            const body = {
                phoneNumber:
                    state.borrowerReducer.application.DIFBrokerPhoneNumber,
                message: `Your Customer ${customerName} with application id ${applicationId} is reffered due to low credit score.`,
                partnerId: state.displayReducer.partner.id,
            };
            postUrl('/api/sendCustomMessage', body);
            dispatch(setDisplay(EDisplays.TEST_DRIVE_INDICATIVELY_REFERRED));
        } else {
            const body = {
                phoneNumber:
                    state.borrowerReducer.application.DIFBrokerPhoneNumber,
                message: `Your Customer ${customerName} with application id ${applicationId} has completed the test drive form.`,
                partnerId: state.displayReducer.partner.partnerId,
            };
            postUrl('/api/sendCustomMessage', body);
            dispatch(setDisplay(EDisplays.TEST_DRIVE_READY));
        }
    }

    return (
        <Button
            id={`${baseId}-button`}
            type={
                disabled
                    ? EButtonType.LONGER_ROUNDED_DISABLED
                    : EButtonType.PRIMARY
            }
            onClick={handleClick}
        >
            I Accept
        </Button>
    );
}
